(function() {

    'use strict';

    angular.module('vhols-dates', []);

    angular.module('vhols-dates').factory('dates', function() {

        /**
         * The date service, provides the ability
         * to manipulate dates using moment underneath.
         * This shields changes in moment in the code
         * base.
         *
         */
        var DatesService = (function() {

            function unwrap(possible) {
                return possible instanceof DatesService ? possible.date : possible;
            }

            function DateService(value, format) {
                value = typeof value == 'undefined' ? new Date() : value;
                this.date = value instanceof Date ? moment(value) : moment(value, format || DateService.defaultFormat);
            }

            DateService.defaultFormat = 'DD/MM/YYYY';
            DateService.years = 'years';
            DateService.months = 'months';
            DateService.weeks = 'weeks';
            DateService.days = 'days';
            DateService.day = 'day';
            DateService.minutes = 'minutes';

            DateService.prototype.asDate = function() {
                return this.date.toDate();
            };

            DateService.prototype.formatISO = function() {
                return this.date.toISOString();
            };

            DateService.prototype.format = function(format) {
                return this.date.format(format || DateService.defaultFormat);
            };

            DateService.prototype.addYears = function(value) {
                this.date.add(value, DateService.years);
                return this;
            };

            DateService.prototype.addMonths = function(value) {
                this.date.add(value, DateService.months);
                return this;
            };

            DateService.prototype.addWeeks = function(value) {
                this.date.add(value, DateService.weeks);
                return this;
            };

            DateService.prototype.addDays = function(value) {
                this.date.add(value, DateService.days);
                return this;
            };

            DateService.prototype.addMinutes = function(value) {
                this.date.add(value, DateService.minutes);
                return this;
            };

            DateService.prototype.isValid = function() {
                return this.date.isValid();
            };

            DateService.prototype.diffYears = function(other) {
                return other.date.diff(this.date, DateService.years);
            };

            DateService.prototype.diffMonths = function(other) {
                return other.date.diff(this.date, DateService.months);
            };

            DateService.prototype.diffWeeks = function(other) {
                return other.date.diff(this.date, DateService.weeks);
            };

            DateService.prototype.diffDays = function(other) {
                return other.date.diff(this.date, DateService.days);
            };

            DateService.prototype.diffMinutes = function(other) {
                return other.date.diff(this.date, DateService.minutes);
            };
            
            DateService.prototype.isBefore = function(other, tolerance) {
                return this.date.isBefore(unwrap(other), tolerance || DateService.day);
            };

            DateService.prototype.isAfter = function(other, tolerance) {
                return this.date.isAfter(unwrap(other), tolerance || DateService.day);
            };

            DateService.prototype.isoWeekday = function() {
                return this.date.isoWeekday();
            };

            DateService.prototype.isSame = function(other, tolerance) {
                return this.date.isSame(unwrap(other), tolerance || DateService.day);
            };

            DateService.prototype.isSameOrBefore = function(other, tolerance) {
                return this.isSame(other, tolerance) || this.isBefore(other, tolerance);
            };

            DateService.prototype.isSameOrAfter = function(other, tolerance) {
                return this.isSame(other, tolerance) || this.isAfter(other, tolerance);
            };

            return DateService;

        })();

        return function(value, format) { // singleton, so return new date service
            return new DatesService(value, format);
        };
    });

})();